
import { defineComponent, PropType, ref, computed } from 'vue';
import { ArrowRight, ArrowDown, ZoomIn, Delete, ArrowLeft, ArrowUp } from '@element-plus/icons-vue';
import { VueDraggableNext } from 'vue-draggable-next';
// import { ElImage } from 'element-plus';
import { IScope } from '@/components/image-viewer';
import TextFileList from './text-file-list.vue';
import useFileList from './hooks/use-file-list';
import type { IFileData } from './types';

// type TElImage = typeof ElImage;

export default defineComponent({
  name: 'FileList',
  components: {
    [ArrowRight.name]: ArrowRight,
    [ArrowDown.name]: ArrowDown,
    [ZoomIn.name]: ZoomIn,
    [Delete.name]: Delete,
    [ArrowLeft.name]: ArrowLeft,
    [ArrowUp.name]: ArrowUp,
  },
  props: {
    list: {
      type: Array as PropType<IFileData[]>,
      default: () => ([]),
    },
    /**
     * 文件列表的类型: picture-card text
     * 默认：picture-card
     */
    listType: {
      type: String,
      default: 'picture-card',
      validator: (val: string) => {
        return ['picture-card', 'text'].indexOf(val) !== -1;
      },
    },
  },
  setup(props) {
    const activeIndex = ref<null | number>(null);

    const {
      uploaderRef,
      handleMove,
      handleDel,
    } = useFileList(props);

    // const imageRef = ref<{ [k: number]: null | TElImage; }>({});

    // const setImageRef = (el: TElImage | null, k: number) => {
    //   imageRef.value[k] = el;
    // };

    // const handlePreview = (i: number) => {
    //   if (imageRef.value[i]) {
    //     // 原生触发点击
    //     const _$img = imageRef.value[i]!.$el?.childNodes[0] as HTMLElement;
    //     _$img?.click?.();
    //   }
    // };

    // const handleReload = (i: number) => {
    //   emit('reload', i);
    // };

    return {
      uploaderRef,
      activeIndex,
      // imageRef,

      previewList: computed(() => {
        return props.list.filter((item) => {
          return !item.type || item.type.indexOf('image/') === 0;
        }).map(item => item.url);
      }),

      // setImageRef,
      handleDel,

      handleMove,
      // handlePreview,
      selfList: computed({
        get() {
          return props.list;
        },
        set(val: IFileData[]) {
          const hasLoading = val.some(item => item.loading);

          if (!hasLoading && uploaderRef.move) {
            uploaderRef.emit('update:modelValue', val);

            uploaderRef.emit('change', val);
          }
        },
      }),
      // handleReload,
    };
  },
  render() {
    if (this.$props.listType === 'text') {
      return (
        <TextFileList list={this.selfList} />
      );
    }
    const fileWrapClassName = `file-item__${this.uploaderRef!.size}`;

    return (
      <VueDraggableNext v-model={this.selfList} class='file-list'>
        {
          this.list.map((item, i) => {
            // 没有类型或者类型为image都当作图片
            const treatAsImage = !item.type || item.type.indexOf('image/') === 0;
            return (
              <image-viewer list={ this.previewList } v-slots={{
                default: ({ view }: IScope) => {
                  return (
                    <div class={['file-item', fileWrapClassName]} key={item.url + i}>
                      {
                        treatAsImage
                          ? <el-image
                              class="file-item__image"
                              fit="cover"
                              v-loading={item.loading}
                              src={item.url}
                            />
                          : item.name || item.url
                      }
                      <div class="file-item__mask">
                        <div
                          class="file-tools__point"
                          onClick={() => this.handleMove(i > 0 && !item.loading, i - 1, i, item)}
                        >
                          {
                            !this.uploaderRef!.disabled && this.uploaderRef!.move && i
                              ? <el-icon size={20}>
                                  {
                                    this.uploaderRef.direction === 'row'
                                      ? <arrow-left />
                                      : <arrow-up />
                                  }
                                </el-icon>
                              : null
                          }
                        </div>
                        <div class="flex flex-wrap space-evenly">
                          {
                            this.uploaderRef!.preview && treatAsImage
                              ? <div class="file-tools__core" onClick={() => view(i)}>
                                <el-icon size={20}>
                                  <zoom-in />
                                </el-icon>
                              </div>
                              : null
                          }
                          {
                            // !this.uploaderRef!.disabled && this.uploaderRef!.reload
                            //   ? <div class="file-tools__core" onClick={ () => this.handleReload(i) }>
                            //       <i class="el-icon-refresh"></i>
                            //     </div>
                            //   : null
                          }
                          {
                            !this.uploaderRef!.disabled && this.uploaderRef!.remove
                              ? <div class="file-tools__core" onClick={() => this.handleDel(i, item)}>
                                <el-icon size={20}>
                                  <delete />
                                </el-icon>
                              </div>
                              : null
                          }
                        </div>
                        <div
                          class="file-tools__point"
                          onClick={() => this.handleMove(i !== this.list.length - 1 && !item.loading, i + 1, i, item)}
                        >
                          {
                            !this.uploaderRef!.disabled && this.uploaderRef!.move && i !== this.list.length - 1
                              ? <el-icon size={20}>
                                  {
                                    this.uploaderRef.direction === 'row'
                                      ? <arrow-right />
                                      : <arrow-down />
                                  }
                                </el-icon>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  );
                },
              }}></image-viewer>
            );
          })
        }
      </VueDraggableNext>
    );
  },
});
